import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AlbumGrid from "@/components/AlbumGrid";
import { ALBUMS } from "@/data/photos";
import { motion } from "framer-motion";
import { Award, Star, Trophy } from "lucide-react";

export default function Ceremonies() {
  const album = ALBUMS.find((a) => a.id === "ceremonies")!;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero banner */}
      {/* @section: ceremonies-hero */}
      <section className="relative h-[55vh] flex items-end pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <img src={album.cover} alt="Cérémonie FGNB" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-[oklch(0.12_0.04_45/0.95)] via-[oklch(0.2_0.07_45/0.6)] to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <span className="inline-block text-accent text-sm font-semibold uppercase tracking-[0.15em] mb-3">Nos récompenses</span>
            <h1 className="text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Cérémonies &amp; <span className="text-accent">Distinctions</span>
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          {/* Intro */}
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center max-w-3xl mx-auto mb-16">
            <p className="text-muted-foreground leading-relaxed text-base">
              La Fondation Gath Naël Beko a été honorée lors de nombreuses cérémonies qui témoignent de la reconnaissance de son engagement humanitaire.
              Ces distinctions sont avant tout un hommage aux bénéficiaires et à toute l'équipe FGNB.
            </p>
          </motion.div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mb-16">
            {[
              { icon: Trophy, label: "Prix reçus", value: "5+" },
              { icon: Star, label: "Cérémonies", value: "10+" },
              { icon: Award, label: "Reconnaissances", value: "Nat. & Int." },
            ].map(({ icon: Icon, label, value }) => (
              <motion.div key={label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                className="bg-card border border-border rounded-3xl p-6 text-center hover:border-accent/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-5 h-5 text-accent" />
                </div>
                <p className="text-3xl font-bold text-foreground mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{value}</p>
                <p className="text-xs text-muted-foreground">{label}</p>
              </motion.div>
            ))}
          </div>

          {/* Album */}
          {/* @section: ceremonies-album */}
          <div className="mb-8">
            <span className="inline-block text-accent text-sm font-semibold uppercase tracking-[0.15em] mb-2">Album photos</span>
            <h2 className="text-3xl font-bold text-foreground mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {album.title}
            </h2>
          </div>
          <AlbumGrid photos={album.photos} columns={3} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
